import React from 'react';
import { Button, CallToAction, Grid2, Typography } from '@riac/design-system';

export const ConsignmentLearnMoreCTA = () => {
  return (
    <Grid2 className='bg-neutral-900 light py-20'>
      <div className='flex flex-col gap-10'>
        <div className='flex flex-col gap-3 sm:gap-5'>
          <Typography className='text-text-contrast' weight='medium' align='center'>Sell With Us</Typography>
          <Typography className='text-[#D7B054] text-[44px] leading-[44px]' weight='bold' expressive size='xs' align='center' heading>Ready to be a Consignor?</Typography>
          <Typography className='text-text-contrast-light' align='center' size='lg'>One simple form starts your journey to sell with the best.</Typography>
        </div>
        <Button variant='secondary' size='lg' className='place-self-center dark' to='/consignment/getting-started'>
          Learn More
        </Button>
      </div>
    </Grid2>
  );
};
